var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","xl":"9","lg":"8"}},[_vm._t("default")],2),_c('b-col',{attrs:{"cols":"12","xl":"3","lg":"4"}},[_vm._t("sidebar")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }